<div class="d-flex flex-row justify-content-between mb-4">
  <button class="btn btn-info mr-3" [style.min-width.px]="102" (click)="inviteUser()">+ Invite user</button>

  <tablesready-search-bar
    placeholder="Search email"
    btnColorClass="btn-light"
    [whiteIconColorEnabled]="false"
    (search)="searchInvite($event)"
  ></tablesready-search-bar>
</div>

<p class="mb-2">We store declined invites for 30 days. Pending invites expire after 2 weeks.</p>

<div class="w-100" [style.overflow-x]="'auto'" *ngIf="invites$ | async as invites">
  <table class="table tr-table tr-striped">
    <thead>
    <tr>
      <th>Email</th>
      <th class="text-center filter-wide">
        <frontend-dropdown
          [items]="inviteRoles"
          [searchable]="false"
          [clearable]="true"
          customClass="old-filter-style"
          [(ngModel)]="inviteUserFilter"
          (ngModelChange)="setFilters({ role: $event === '' ? null : $event })"
          placeholder="Role"
          bindLabel="title"
          bindValue="value"
          maxListHeight="9.3rem"
        ></frontend-dropdown>
      </th>
      <th class="text-center">Date</th>
      <th class="text-center filter-wide">
        <frontend-dropdown
          [items]="inviteStatuses"
          [searchable]="false"
          [clearable]="true"
          customClass="old-filter-style"
          [(ngModel)]="statusFilter"
          (ngModelChange)="setFilters({ status: $event === '' ? null : $event })"
          placeholder="Status"
          bindLabel="title"
          bindValue="value"
          maxListHeight="9.3rem"
        ></frontend-dropdown>
      </th>
      <th class="text-center">Actions</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let invite of invites | slice: start : end">
      <td class="font-weight-bold">
        {{invite.email}}
        <info-badge
          *ngIf="invite.locations.length > 1"
          tooltip="Only an account admin can cancel or resend invites for this user"
          label="?"
        ></info-badge>
      </td>
      <td class="text-center" [innerText]="inviteRolesMap[invite.role]"></td>
      <td class="text-center" [innerText]="invite.createdAt | trDateFormat: 'MM/DD/YYYY': timezone"></td>
      <td class="text-center">
        <div class="d-flex flex-row justify-content-center bbadge">
        <span
          class="font-weight-bold w-75"
          [class.status-expired]="invite.status === inviteStatus.expired"
          [class.status-declined]="invite.status === inviteStatus.declined"
          [class.status-pending]="invite.status === inviteStatus.pending"
          [innerText]="inviteStatusesMap[invite.status] | uppercase"
        ></span>
        </div>
      </td>
      <td class="text-center">
        <div *ngIf="invite.locations.length === 1" class="d-flex flex-row align-items-center justify-content-center actions">
          <button *ngIf="invite.status !== inviteStatus.declined" class="btn btn-info mr-2" (click)="resend(invite)">Resend</button>
          <button class="btn btn-danger" (click)="cancel(invite)">Cancel</button>
        </div>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="d-flex flex-row justify-content-end">
    <div class="paginator" *ngIf="invites.length > 0">
      <ngb-pagination
        [(page)]="page"
        [pageSize]="pageSize"
        [maxSize]="maxSize"
        [ellipses]="true"
        [collectionSize]="invites.length"
      ></ngb-pagination>
    </div>
  </div>
</div>
